export { default as PromotionItemController } from './PromotionItem.controller'
